// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadOrders from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrders";
import { getOrdersDataView } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CardContainer, { CardContainerStyles } from "@insite/content-library/Components/CardContainer";
import CardList, { CardListStyles } from "@insite/content-library/Components/CardList";
// import CardListHeading from "@insite/content-library/Components/CardListHeading"; // Starter Custom Code
import OrderSummaryCard, { OrderSummaryCardStyles } from "@insite/content-library/Components/OrderSummaryCard";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import * as cssLinter from "css";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import CardListHeading from "@store/Overrides/Components/CardListHeading";
import { tableProps } from "@store/Themes/common/props/table";
import { typographyGetNoResultsProps } from "@store/Themes/common/props/typography";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import withHookProps, { HookPropsInjector } from "@toolkit/Framework/Common/Utilities/withHookProps";

interface HookProps {
    persistentDataView: ReturnType<typeof getOrdersDataView>;
}

const hookPropsInjector: HookPropsInjector<Props, HookProps> = ({ ordersDataView }) => ({
    persistentDataView: usePersistentDataView(ordersDataView),
});
/* Starter Custom Code - End */

const enum fields {
    numberOfRecords = "numberOfRecords",
    customCSS = "customCSS",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.numberOfRecords]: number;
        [fields.customCSS]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    const isAuthenticated = session.isAuthenticated && !session.isGuest;
    return {
        ordersDataView: getOrdersDataView(state, recentOrdersParameter),
        orderHistoryPageLink: getPageLinkByPageType(state, "OrderHistoryPage"),
        settingsCollection: getSettingsCollection(state),
        canViewOrders: isAuthenticated && (session.userRoles || "").indexOf("Requisitioner") === -1,
    };
};

const mapDispatchToProps = {
    loadOrders,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HookProps; // Starter Custom Code

export interface RecentOrdersStyles {
    cardList?: CardListStyles;
    errorGridItem?: GridItemProps;
    errorText?: TypographyPresentationProps;
    noOrdersFoundGridItem?: GridItemProps;
    noOrdersFoundText?: TypographyPresentationProps;
    cardContainer?: CardContainerStyles;
    orderSummaryCard?: OrderSummaryCardStyles;
    // Starter Custom Code
    wrapper?: InjectableCss;
    loadingOverlay?: LoadingOverlayProps;
    tableWrapper?: InjectableCss;
    dataTable?: DataTableProps;
    orderNumberHeader?: DataTableHeaderProps;
    dateHeader?: DataTableHeaderProps;
    shipToHeader?: DataTableHeaderProps;
    customerPOHeader?: DataTableHeaderProps;
    statusHeader?: DataTableHeaderProps;
    orderTotalHeader?: DataTableHeaderProps;
}

export const recentOrdersStyles: RecentOrdersStyles = {
    loadingOverlay: { minHeight: 80 },
    tableWrapper: tableProps.wrapper,
    noOrdersFoundText: typographyGetNoResultsProps(),
    dataTable: tableProps.dataTable,
    shipToHeader: tableProps.tightHeader,
    orderTotalHeader: tableProps.amountHeader,
};

/* Starter Custom Code - Start */
const defaultCustomCss = `.card-list-heading{
}

.view-all-link{
}

.no-orders-found-text{
}`;
/* Starter Custom Code - End */

let recentOrdersParameter: GetOrdersApiParameter = {
    customerSequence: "-1",
    page: 1,
    sort: "OrderDate DESC",
};

const styles = recentOrdersStyles;

class RecentOrders extends React.Component<Props> {
    componentDidMount() {
        recentOrdersParameter.pageSize = this.props.fields.numberOfRecords;
        if (this.props.canViewOrders && !this.props.ordersDataView.value) {
            this.props.loadOrders(recentOrdersParameter);
        }
    }

    render() {
        const { ordersDataView, orderHistoryPageLink, settingsCollection, canViewOrders } = this.props;
        if (!canViewOrders /* Starter Removed - !ordersDataView.value */) {
            return null;
        }

        const orderHistoryUrl = orderHistoryPageLink ? orderHistoryPageLink.url : undefined;

        /* Starter Custom Code - Start */
        const customCssWrapper = css`
            ${styles.wrapper?.css}
            ${this.props.fields.customCSS}
        `;

        const hasNoResults = !ordersDataView.value || ordersDataView.value.length === 0;

        return (
            <StyledWrapper {...styles.wrapper} css={customCssWrapper} data-test-selector="widget_RecentOrders">
                <CardListHeading
                    heading={translate("Recent Orders")}
                    viewAllUrl={orderHistoryUrl}
                    hasNoResults={hasNoResults}
                />
                <DataViewLoadingOverlay {...styles.loadingOverlay} dataView={this.props.persistentDataView}>
                    {hasNoResults ? (
                        <Typography
                            className="no-orders-found-text"
                            {...styles.noOrdersFoundText}
                            data-test-selector="recentOrders_NoOrdersFound"
                        >
                            {translate("No orders found")}
                        </Typography>
                    ) : (
                        <StyledWrapper {...styles.tableWrapper}>
                            <DataTable {...styles.dataTable}>
                                <DataTableHead>
                                    <DataTableHeader {...styles.orderNumberHeader}>
                                        {translate("Order #")}
                                    </DataTableHeader>
                                    <DataTableHeader {...styles.dateHeader}>{translate("Date")}</DataTableHeader>
                                    <DataTableHeader {...styles.shipToHeader}>
                                        {translate("Ship To / Pick Up")}
                                    </DataTableHeader>
                                    <DataTableHeader {...styles.customerPOHeader}>{translate("PO #")}</DataTableHeader>
                                    <DataTableHeader {...styles.statusHeader}>{translate("Status")}</DataTableHeader>
                                    <DataTableHeader {...styles.orderTotalHeader}>{translate("Total")}</DataTableHeader>
                                </DataTableHead>
                                <DataTableBody>
                                    {ordersDataView.value?.map(
                                        order =>
                                            order !== null && (
                                                <OrderSummaryCard
                                                    key={order.id}
                                                    order={order}
                                                    orderSettings={settingsCollection.orderSettings}
                                                    extendedStyles={styles.orderSummaryCard}
                                                />
                                            ),
                                    )}
                                </DataTableBody>
                            </DataTable>
                        </StyledWrapper>
                    )}
                </DataViewLoadingOverlay>
            </StyledWrapper>
        );
        /* Starter Custom Code - End */
    }
}

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHookProps(RecentOrders, hookPropsInjector)), // Starter Custom Code
    definition: {
        group: "Common",
        icon: "list-ul",
        fieldDefinitions: [
            {
                name: fields.numberOfRecords,
                displayName: "Number of Recent Orders Displayed",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 5,
                fieldType: "General",
                sortOrder: 1,
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
